import type { CTALabels, Status } from '../index.types';

export function getCTALabel(status: Status, labels: CTALabels): string {
	switch (status) {
		case 'success':
			return labels.successLabel;
		case 'error':
			return labels.errorLabel;
		case 'pending':
			return labels.pendingLabel;
		default:
			return labels.defaultLabel;
	}
}
